// src/pages/FormPage/renderers/DefaultRenderer.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';
import { FormImage, MaskWidget, ActionButtonWidget } from '../widgets';
import { useTheme } from '../../../hooks/useTheme';

/**
 * Renderiza o formulário padrão com RJSF
 * @param {object} props
 * @param {object} props.formSchema
 * @param {object} props.uiSchema
 * @param {object} props.formData
 * @param {function} props.onSubmit
 * @param {function} props.onChange
 * @param {boolean} props.disabled
 * @param {object} props.config
 * @returns {JSX.Element}
 */
const DefaultRenderer = ({
  formSchema,
  uiSchema,
  formData,
  onSubmit,
  onChange,
  disabled,
  config
}) => {
  const theme = config?.theme || 'lumen';
  useTheme(theme); // ⬅️ Aplica o tema dinamicamente e com persistência

  const customFields = { image: FormImage };
  const customWidgets = { MaskWidget, ActionButtonWidget };

  return (
    <>
      <Helmet>
        <title>{config?.title || 'Formulário'}</title>
      </Helmet>
      <div className="card p-4">
        <Form
          schema={formSchema}
          uiSchema={uiSchema}
          formData={formData}
          validator={validator}
          onSubmit={onSubmit}
          onChange={onChange}
          disabled={disabled}
          fields={customFields}
          widgets={customWidgets}
        >
          <button type="submit" className="btn btn-info" disabled={disabled}>
            {disabled ? 'Aguarde...' : config?.submitButtonText || 'Enviar informações'}
          </button>
        </Form>
      </div>
    </>
  );
};

export default DefaultRenderer;
